// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__15qdC","colMin":"styles_colMin__3I1JN"};